// frontend/src/components/ResetPassword.tsx
import React, { useState } from 'react';
import { Container, Card, Form, Button, Alert, InputGroup } from 'react-bootstrap';
import { useNavigate, useParams, Link } from 'react-router-dom';
import axios from 'axios';

import { buildApiUrl } from '../config/api';

const ResetPassword: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    new_password: '',
    new_password2: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (formData.new_password !== formData.new_password2) {
      setError('הסיסמאות אינן תואמות');
      return;
    }

    if (formData.new_password.length < 8) {
      setError('הסיסמה חייבת להכיל לפחות 8 תווים');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(buildApiUrl('users/auth/reset-password/confirm/'), {
        token,
        username: formData.username.trim(),
        new_password: formData.new_password,
        new_password2: formData.new_password2
      });
      
      setSuccess(response.data.message);
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } catch (err: any) {
      const d = err.response?.data?.details;
      if (typeof d === 'string') {
        setError(d);
      } else if (d && typeof d === 'object') {
        setError(Object.values(d).flat().join(' ') || err.response?.data?.error || 'שגיאה באיפוס סיסמה');
      } else {
        setError(err.response?.data?.error || 'שגיאה באיפוס סיסמה');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="mt-5" style={{ maxWidth: '600px', direction: 'rtl' }}>
      <Card>
        <Card.Header as="h3" className="text-center">
          איפוס סיסמה
        </Card.Header>
        <Card.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          {success && (
            <Alert variant="success">
              {success}
              <br />
              <small>מעביר אותך להתחברות...</small>
            </Alert>
          )}
          
          {!success && (
            <Form onSubmit={handleSubmit}>
              <Alert variant="info">
                הזן את שם המשתמש שלך (כפי שאתה מתחבר איתו) ואת הסיסמה החדשה.
              </Alert>

              <Form.Group className="mb-3">
                <Form.Label>שם משתמש *</Form.Label>
                <Form.Control
                  type="text"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  required
                  disabled={loading}
                  autoComplete="username"
                  placeholder="הזן את שם המשתמש שלך"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>סיסמה חדשה * (לפחות 8 תווים)</Form.Label>
                <InputGroup>
                  <Form.Control
                    type={showPassword ? 'text' : 'password'}
                    name="new_password"
                    value={formData.new_password}
                    onChange={handleChange}
                    required
                    minLength={8}
                    disabled={loading}
                    autoComplete="new-password"
                  />
                  <Button
                    variant="outline-secondary"
                    onClick={() => setShowPassword(!showPassword)}
                    disabled={loading}
                  >
                    {showPassword ? <i className="fas fa-eye-slash"></i> : <i className="fas fa-eye"></i>}
                  </Button>
                </InputGroup>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>אימות סיסמה *</Form.Label>
                <InputGroup>
                  <Form.Control
                    type={showPassword2 ? 'text' : 'password'}
                    name="new_password2"
                    value={formData.new_password2}
                    onChange={handleChange}
                    required
                    minLength={8}
                    disabled={loading}
                    autoComplete="new-password"
                  />
                  <Button
                    variant="outline-secondary"
                    onClick={() => setShowPassword2(!showPassword2)}
                    disabled={loading}
                  >
                    {showPassword2 ? <i className="fas fa-eye-slash"></i> : <i className="fas fa-eye"></i>}
                  </Button>
                </InputGroup>
              </Form.Group>

              <Button
                variant="primary"
                type="submit"
                className="w-100 mb-3"
                disabled={loading}
              >
                {loading ? 'מאפס...' : 'אפס סיסמה'}
              </Button>
            </Form>
          )}

          <hr />

          <div className="text-center">
            <Link to="/login" className="text-muted">
              חזרה להתחברות
            </Link>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ResetPassword;
